import { v1 as uuidv1 } from 'uuid';
import * as d3 from "d3";
import * as legend from "d3-svg-legend";
import { legendColor } from 'd3-svg-legend'

class LegendBuilder {
  constructor(map) {
    if (!map) throw new Error("Esperada a instância do mapa: map");
    this._map = map;
    this._title = "Legenda";
    this._scale = "ordinal";
    this.mapControls = new MapboxControls();
    this.legendFormat = new LegendFormat();
  }

  //region Fields
  get Scale() {
    return this._scale;
  }
  get Title() {
    return this._title;
  }
  //endregion

  addCartographic(layers, includeMarkers = true, container = null) {
    throw new Error("Not implemented exception");
  }
  addLinearScale(options = {}) {
    if (!options) throw new Error("Esperada as configurações da legenda");
    try {
      if (options.container === null) {
        const legend = this.mapControls.getLegendControl(uuidv1());
        this._map.addControl(legend, this.legendFormat.Anchor);
        options.container = legend.id;
      }
      const svg = d3.select("#" + options.container);
      const linear = d3.scaleSqrt()
        .domain(options.domain)
        .range(options.range);
      const legend = legend.legendSize()
        .labelFormat(d3.format(options.format || this.legendFormat.Format))
        .title(`${options.title || this.Title}`)
        .scale(linear)
        .shape('circle')
        .shapePadding(this.legendFormat.ShapePadding)
        .labelOffset(this.legendFormat.LabelOffset)
        .orient(this.legendFormat.Orientation);

      svg.append("g")
        .attr("class", `${options.container}-legendLinear`)
        .attr("transform", this.legendFormat.Transform);
      svg.select(`.${options.container}-legendLinear`)
        .call(legend);

      $(`.${options.container}-legendLinear circle`).css({'fill': this.Range})
      return options.container;
    } catch (e) {
      console.log(e);
    }
  }
  addOrdinalScale(themeId, options = {}) {
    if (!options) throw new Error("Esperada as configurações da legenda");
    try {
      if (!options.container) {
        const legend = new LegendControl(themeId, options.title, options.cssClass || null);
        this._map.addControl(legend, this.legendFormat.Anchor);
        options.container = legend.SvgId;
      }
      const svg = d3.select("#" + options.container);
      const ordinal = d3.scaleOrdinal()
        .domain(options.data.domain)
        .range(options.data.colors);

      const legend = legendColor()
        .labelFormat(d3.format(options.format || this.legendFormat.Format))
        .title(`${options.title || this.Title}`)
        .cells(10)
        .scale(ordinal);

      if (options.symbol) {
        legend.shape("path", d3.symbol().type(this.getSymbol(options.symbol.type)).size(options.symbol.size)())
        legend.shapePadding(this.legendFormat.ShapePadding)
      }

      svg.append("g")
        .attr("class", `${options.container}-legendOrdinal`)
        .attr("transform", this.legendFormat.Transform);
      svg.select(`.${options.container}-legendOrdinal`)
        .call(legend);
      return options.container;
    } catch (e) {
      console.log(e);
    }
  }
  addQuantileScale(options = {}) {
    if (!options) throw new Error("Esperada as configurações da legenda");
    try {
      if (options.container === null) {
        const legend = this.mapControls.getLegendControl(uuidv1());
        this._map.addControl(legend, this.legendFormat.Anchor);
        options.container = legend.id;
      }
      const svg = d3.select("#" + container);
      const quantile = d3.scaleQuantile()
        .domain(options.domain)
        .range(options.range);

      const legend = legend.legendColor()
        .labelFormat(d3.format(options.format || this.legendFormat.Format))
        .labelDelimiter(this.legendFormat.LabelDelimiter)
        .title(`${options.title || this.Title}`)
        .cells(10)
        .scale(quantile);
      /*.labels(function({i,genLength,generatedLabels,labelDelimiter}) {
          if (i === 0) {
              const values = generatedLabels[i].split(` ${labelDelimiter} `)
              return `Less than ${values[1]}`
          }
          if (i === genLength - 1) {
              const values = generatedLabels[i].split(` ${labelDelimiter} `)
              return `${values[0]} ou mais`
          }
          return generatedLabels[i]
      });*/
      svg.append("g")
        .attr("class", `${options.container}-legendQuant`)
        .attr("transform", "translate(20,20)");

      svg.select(`.${options.container}-legendQuant`)
        .call(legend);
      return options.container;
    } catch (e) {
      console.log(e);
    }
  }
  addQuantizeScale(options = {}) {
    if (!options) throw new Error("Esperada as configurações da legenda");
    try {
      if (options.container === null) {
        const legend = this.mapControls.getLegendControl(uuidv1());
        this._map.addControl(legend, this.legendFormat.Anchor);
        options.container = legend.id;
      }
      const svg = d3.select("#" + container);
      const quantize = d3.scaleQuantize()
        .domain(options.domain)
        .range(options.range);

      const legend = legend.legendColor()
        .labelFormat(d3.format(options.format || this.legendFormat.Format))
        .labelDelimiter(this.legendFormat.LabelDelimiter)
        .title(`${options.title || this.Title}`)
        .cells(10)
        .scale(quantize);
      /*.labels(function({i,genLength,generatedLabels,labelDelimiter}) {
          if (i === 0) {
              const values = generatedLabels[i].split(` ${labelDelimiter} `)
              return `Less than ${values[1]}`
          }
          if (i === genLength - 1) {
              const values = generatedLabels[i].split(` ${labelDelimiter} `)
              return `${values[0]} ou mais`
          }
          return generatedLabels[i]
      });*/
      svg.append("g")
        .attr("class", `${options.container}-legendQuant`)
        .attr("transform", this.legendFormat.Transform);

      svg.select(`.${options.container}-legendQuant`)
        .call(legend);
      return options.container;
    } catch (e) {
      console.log(e);
    }
  }
  addThresholdScale(themeId, options = {}) {
    if (!options) throw new Error("Esperada as configurações da legenda");
    try {
      if (!options.container) {
        const legend = new LegendControl(themeId, options.cssClass || null);
        this._map.addControl(legend, this.legendFormat.Anchor);
        options.container = legend.SvgId;
      }
      const svg = d3.select("#" + container);
      const quantile = d3.scaleThreshold()
        .domain(options.data.domain)
        .range(options.data.range);

      const legend = legend.legendColor()
        .labelFormat(d3.format(options.format || this.legendFormat.Format))
        .labelDelimiter(this.legendFormat.LabelDelimiter)
        .title(`${options.title || this.Title}`)
        .cells(10)
        .scale(quantile)
        .labels(function ({i, genLength, generatedLabels, labelDelimiter}) {
          if (i === 0) {
            const values = generatedLabels[i].split(` ${labelDelimiter} `)
            return `Menor que ${values[1]}`
          }
          if (i === genLength - 1) {
            const values = generatedLabels[i].split(` ${labelDelimiter} `)
            return `Maior que ${values[0]}`
          }
          return generatedLabels[i]
        });
      svg.append("g")
        .attr("class", `${options.container}-legendThres`)
        .attr("transform", this.legendFormat.Transform);

      svg.select(`.${options.container}-legendThres`)
        .call(legend);
      return options.container;
    } catch (e) {
      console.log(e);
    }
  }
  AttachMap(map) {
    this._map = map
  }
  DetachMap() {
    this._map = null;
  }
  getSymbol(symbolName) {
    if (symbolName === "circle") {
      return d3.symbolCircle;
    } else if (symbolName === "cross") {
      return d3.symbolCross;
    } else if (symbolName === "diamond") {
      return d3.symbolDiamond;
    } else if (symbolName === "square") {
      return d3.symbolSquare;
    } else if (symbolName === "star") {
      return d3.symbolStar;
    } else if (symbolName === "triangle") {
      return d3.symbolTriangle;
    } else {
      return d3.symbolWye;
    }
  }
  remove(legendId) {
    try {
      const legend = document.getElementById(legendId);
      const button = document.getElementById(`controlButton_${legendId}`);
      if (legend && legend.parentNode)
        legend.parentNode.removeChild(legend)
      if (button && button.parentNode)
        button.parentNode.removeChild(button)
      return true;
    } catch (e) {
      throw e;
    }
  }
  render(themeId, options = {}) {
    if (!themeId) throw new Error("Esperado o parâmetro 'themeId'");
    if (typeof options !== 'object') throw new Error("A legenda precisa de opções");
    if (!options.scale) options.scale = "ordinal";
    //if (!stringUtils.SCALE_TYPES.includes(scaleType)) throw new Error("A propriedade 'scaleType' está fora do intervalo");

    const svgId = `theme-legend-${themeId}`;

    switch (options.scale.toLocaleLowerCase()) {
      case "linear":
        this.addLinearScale(svgId, options);
        break;
      case "ordinal":
        this.addOrdinalScale(themeId, options);
        break;
      case "quantile":
        this.addQuantileScale(svgId, options);
        break;
      case "quantize":
        this.addQuantizeScale(svgId, options);
        break;
      case "threshold":
        this.addThresholdScale(svgId, options);
        break;
    }
  }
}

class LegendControl {
  constructor(themeId, title = null, cssClass = null) {
    this._container = null;
    this._id = null;
    this._title = title;
    this._svgId = null;
    this._cssClass = cssClass;
    this._themeId = themeId;
    this._map = null;
  }

  get Id() {
    return this._id;
  }

  get SvgId() {
    return this._svgId;
  }

  addToolbar(container) {
    const toolbar = document.createElement('div');
    toolbar.className = "icon-bar";
    toolbar.style.background = 'gray !important';
    //toolbar.style.float = 'right';
    const btn1 = document.createElement('a');
    const icon1 = document.createElement("i");
    btn1.className = "active";
    btn1.style.color = "white !important";
    btn1.title = "Fechar";

    btn1.addEventListener("click", event => {
      this._legendContainer.style.display = 'none';
      this._controlButton.style.display = 'block';
    });

    icon1.className = "fa fa-window-close fa-lg";
    btn1.appendChild(icon1);
    toolbar.appendChild(btn1);
    container.appendChild(toolbar);
  }

  appendSVGChild(element, target, attributes = {},text = '') {
    let e = document.createElementNS('http://www.w3.org/2000/svg',element);
    Object.entries(attributes).map(a => e.setAttribute(a[0],a[1]));
    if (text) {
      e.textContent = text;
    }
    target.appendChild(e);
    return e;
  }

  onAdd(map) {
    this._map = map;
    const mapId = map.getContainer().id;
    this._id = `${mapId}-legend-${this._themeId}`;
    this._container = document.createElement('div');
    this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
    this._controlButton = document.createElement("button");
    this._legendContainer = document.createElement("div");
    this._legendContainer.id = this._id;
    this._legendContainer.style.background = '#FFFFFF';
    this._controlButton.id = `controlButton_${this._id}`;
    this._controlButton.title = this._title || "Legenda";
    this._controlButton.style.display = 'none';
    this._controlButton.type = "button";
    this._controlButton.classList.add("mapboxgl-ctrl-icon");
    const styleIcon = document.createElement("i");
    styleIcon.className = "fa fa-window-maximize";
    this._controlButton.appendChild(styleIcon);

    this._controlButton.addEventListener("click", event => {
      this._legendContainer.style.display = 'block';
      this._controlButton.style.display = 'none';
    });

    this._container.appendChild(this._controlButton);
    this._container.appendChild(this._legendContainer);
    this._svgId = `theme-legend-${this._themeId}`;
    this.addToolbar(this._legendContainer);
    this.appendSVGChild('svg', this._legendContainer, {id: this._svgId, style: "width:220px;height:160px;overflow-y: scroll;"});
    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._legendContainer = undefined;
    this._controlButton = undefined;
    this._map = undefined;
  }
}

class LegendFormat {
  constructor() {
    this._format = "";
    this._anchor = 'bottom-right';
    this._labelDelimiter = "a";
    this._labelOffset = 5;
    this._orientation = "vertical";
    this._transform = "translate(20,20)";
    this._shapePadding = 10;
  }

  //region Fields
  get Anchor() {
    return this._anchor;
  }
  set Anchor(value) {
    this._anchor = value;
  }
  get Format() {
    return this._format;
  }
  set Format(value) {
    this._format = value;
  }
  get LabelDelimiter() {
    return this._labelDelimiter;
  }
  set LabelDelimiter(value) {
    this._labelDelimiter = value;
  }
  get LabelOffset() {
    return this._labelOffset;
  }
  set LabelOffset(value) {
    this._labelOffset = value;
  }
  get Orientation() {
    return this._orientation;
  }
  set Orientation(value) {
    this._orientation = value;
  }
  get ShapePadding() {
    return this._shapePadding;
  }
  set ShapePadding(value) {
    this._shapePadding = value;
  }
  get Transform() {
    return this._transform;
  }
  set Transform(value) {
    this._transform = value;
  }
  //endregion

}

class MapboxControls {
  constructor() {
  }
  getLegendControl(themeId) {
    function LegendControl() {
      this.id = null;
    }

    LegendControl.prototype.onAdd = function(map) {
      this._map = map;
      const mapId = map.getContainer().id;
      this.id = `${mapId}-legend-${themeId}`;
      this._container = document.createElement('div');
      this._container.className = "mapboxgl-ctrl";
      const mapLegendContainer = document.createElement("div");
      mapLegendContainer.id = this.id;
      this._container.appendChild(mapLegendContainer);
      return this._container;
    }

    LegendControl.prototype.onRemove = function () {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    };

    return new LegendControl;
  }
}

export { LegendBuilder };
